import React from 'react';
import { TrendingUp, Award, AlertTriangle, Brain, Network, FileText } from 'lucide-react';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: <TrendingUp size={28} />,
      title: "Maximización del Rendimiento Productivo",
      description: "El sistema analiza las variables de entrada de tus ciclos de producción para identificar las combinaciones que generan un mayor volumen de resultados. Aumenta tu producción utilizando los mismos recursos, basándote en predicciones precisas."
    },
    {
      icon: <Award size={28} />,
      title: "Optimización de la Calidad del Producto Final",
      description: "Define tus indicadores de calidad ideales (mayor peso, calibre específico, durabilidad, etc.) y la IA te recomendará las mezclas de insumos y condiciones de proceso necesarias para alcanzarlos de manera consistente, mejorando el valor de tu producto."
    },
    {
      icon: <AlertTriangle size={28} />,
      title: "Reducción Radical de Ineficiencias",
      description: "La plataforma identifica y te alerta sobre las combinaciones de recursos que históricamente han demostrado ser poco productivas. Deja de invertir tiempo, materiales y esfuerzo en procesos de bajo rendimiento y enfócate solo en las estrategias que funcionan."
    },
    {
      icon: <Brain size={28} />,
      title: "Decisiones Estratégicas Basadas en Evidencia",
      description: "Opera con total confianza. Cada recomendación del motor se fundamenta en un análisis exhaustivo de tus datos históricos, dándote la seguridad de que cada decisión está calculada para acercarte a tus objetivos de negocio."
    },
    {
      icon: <Network size={28} />,
      title: "Mapa Visual de Causa y Efecto",
      description: "Explora un mapa interactivo que revela cómo interactúan las diferentes variables de tu proceso. Comprende de un vistazo qué factores tienen el mayor impacto en tus resultados y descubre oportunidades de mejora que antes eran invisibles."
    },
    {
      icon: <FileText size={28} />,
      title: "Informes Inteligentes para una Gestión Ágil",
      description: "Recibe análisis claros y concisos que traducen datos complejos en planes de acción inmediatos. Acelera tu capacidad de respuesta y adapta tu estrategia productiva en tiempo real basándote en información fiable y fácil de interpretar."
    }
  ];

  return (
    <section className="benefits-section">
      <div className="benefits-header">
        <h2 className="benefits-main-title">Tu Centro de Mando para la Optimización de Procesos</h2>
        <p className="benefits-main-subtitle">
          Utiliza la inteligencia artificial de Gestas ML para convertir los datos de tu operación en decisiones estratégicas que impulsan la eficiencia y el rendimiento.
        </p>
        <h3 className="benefits-section-title">Beneficios Clave de la Herramienta</h3>
      </div>
      
      <div className="timeline-container">
        <div className="timeline-line"></div>
        {benefits.map((benefit, index) => (
          <div key={index} className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}>
            <div className="timeline-content">
              <div className="timeline-icon">
                {benefit.icon}
              </div>
              <h4 className="timeline-title">{benefit.title}</h4>
              <p className="timeline-description">{benefit.description}</p>
            </div>
            <div className="timeline-point"></div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BenefitsSection;